import { Badge } from '@/components/ui'
import { useT } from '@/internationalization/i18n'
import type { LeaveReason, MeetingStatus } from '@/types'
import { resolveMeetingStatusBadge } from './meetingStatusMap'

export function MeetingStatusBadge({
  status,
  leaveReason,
}: {
  status: MeetingStatus
  leaveReason?: LeaveReason | null
}) {
  const t = useT()
  const { key, tone, dot } = resolveMeetingStatusBadge(status, leaveReason)
  return (
    <Badge tone={tone} dot={dot}>
      {t(key)}
    </Badge>
  )
}
